import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { documentStatusToStep } from "@shared/utils/document-status-to-step";
import {
  getGenerateDocumentInvoicePath,
  getGenerateDocumentPath,
  getImportedDocumentPagePath
} from "@shared/utils/route-path-utils";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { DocumentRecord } from "@models/annual-statements/document-record";
import { DocumentStatusEnum } from "@models/documents/document-status.enum";

type CellRendererParams = ICellRendererParams<DocumentRecord> & {
  documentCanBeOpened: boolean;
};

@Component({
  selector: 'app-ag-document-name',
  standalone: true,
  imports: [RouterLink],
  templateUrl: 'ag-document-name.component.html',
  styleUrl: 'ag-document-name.component.scss'
})
export class AgDocumentNameComponent implements ICellRendererAngularComp {
  documentId = '';
  documentCanBeOpened = false;
  isDocumentInvoice = false;
  isDocumentImported = false;
  link: string[] | null = null;
  queryParams: Record<string, number | null> = {};
  name = '';

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.documentId = params.data?.documentId ?? '';
    this.isDocumentInvoice = DocumentRecord.isDocumentInvoice(params.data ?? {});
    this.isDocumentImported = DocumentRecord.isImportedDocument(params.data ?? {});
    this.documentCanBeOpened = params.documentCanBeOpened && !!this.documentId;
    this.link = this.getRouterLink();
    this.queryParams = this.getQueryParams(params.data?.status);
    this.name = params.data?.documentName ?? '';
    return true;
  }

  getRouterLink(): string[] | null {
    if (!this.documentCanBeOpened) {
      return null;
    }

    if (this.isDocumentImported) {
      return getImportedDocumentPagePath(this.documentId);
    }

    return this.isDocumentInvoice
      ? getGenerateDocumentInvoicePath(this.documentId)
      : getGenerateDocumentPath(this.documentId);
  }

  getQueryParams(documentStatus: DocumentStatusEnum | null | undefined): Record<string, number | null> {
    const params: Record<string, number | null> = {};

    if (this.documentCanBeOpened && !this.isDocumentInvoice && !this.isDocumentImported) {
      params['step'] = documentStatusToStep(documentStatus);
    }

    return params;
  }
}
